import * as React from "react";
import ExperienceCard from "../../../components/base/card/experienceCard";

const TabExperiences = ({
  experiences,
  gviExperiencesLabel,
  gviExperiencesDescription
}) => {
  const tabData = {
    title: "GVI experiences",
    createdAt: 1639446722,
    description:
      "Whilst on this program, you’ll also have the opportunity to experience tailor-made adventure and wellness activities, geared towards further creating or learning about the impact etc. etc.",
    exclusiveCaption: "Exclusive local GVI experiences"
  };
  return (
    <>
      <div className="">
        <div className="py-4 border-b tab-content-head border-b-gray-light">
          <div
            className="font-light text-xlrg-sm leading-[38px] dark:text-white text-generic-text"
            dangerouslySetInnerHTML={{ __html: gviExperiencesLabel }}
          />
        </div>
        <div className="py-8 tab-content-description">
          <div
            className="dark:text-gray-generic text-generic-text"
            dangerouslySetInnerHTML={{
              __html: gviExperiencesDescription
            }}
          />
        </div>
        <div className="tab-content-body">
          <div
            className="py-2 dark:text-white text-generic-text text-xl leading-[24px] font-light hidden"
            dangerouslySetInnerHTML={{ __html: tabData.exclusiveCaption }}
          />
          <div className="grid grid-cols-2 gap-4">
            {experiences &&
              experiences.length > 0 &&
              experiences?.map((experience, idx) => {
                const experienceTitle = experience.experienceTitle;
                const experienceFeaturedImage =
                  experience?.experienceFeaturedImage?.sourceUrl;
                const experienceIconImage =
                  experience?.experienceIcon?.sourceUrl;
                const experienceDescription = experience?.experienceOneliner;

                return (
                  <div className="flex flex-col rounded-md" key={idx}>
                    <ExperienceCard
                      bgImage={""}
                      fallbackImage={experienceFeaturedImage}
                      experienceTitle={experienceTitle}
                      iconImage={""}
                      fallbackIcon={experienceIconImage}
                      experienceDescription={experienceDescription}
                      isRounded={true}
                      isRoundedTop={false}
                    />
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
};

export default TabExperiences;
